import { NgModule } from '@angular/core';
import { PreloadAllModules, RouterModule, Routes } from '@angular/router';
import { AuthComponent } from './auth/auth.component';
import { AuthGuard } from '../app/auth/_guards/auth.guard';
import { PrivacyPolicyComponent } from './privacy-policy/privacy-policy.component';
import { CorporateSafetyComponent } from './pages/corporate-safety/corporate-safety.component';
import { AcknowledgementComponent } from './acknowledgement/acknowledgement.component';
import { CommonModule } from '@angular/common';
import { LoginRedirectGuard } from './auth/_guards/login-redirect.guard';
import { AccessDeniedComponent } from './pages/access-denied/access-denied.component';



const routes: Routes = [
  { path: 'auth', canActivate: [LoginRedirectGuard],component: AuthComponent,data :{sidebar:false, title:"Authenticating"} },
  { path: 'access-denied', component: AccessDeniedComponent,data :{sidebar:false, title:"Access denied",width:'full'}  },
  { path: 'page/privacy-policy', component: PrivacyPolicyComponent,data :{sidebar:false, title:"Privacy policy view",width:'full'}  },
  { path: 'page/acknowledge/:action_type', component: AcknowledgementComponent,data :{sidebar:false, title:"Acknowledge view",width:'full'}  },
  { 
    path: '',
    canActivate: [AuthGuard],
    children: [
      { path: '', redirectTo: 'home', pathMatch: 'full' },
      { path: 'home', loadChildren: () => import('../app/pages/home/home.module').then( m => m.HomePageModule) },
      { path: 'profile', loadChildren: () => import('../app/pages/profile/profile.module').then( m => m.ProfileModule) },
      { path: 'documents', loadChildren: () => import('../app/pages/documents/documents.module').then( m => m.DocumentsModule) },
      { path: 'payroll-expenses', loadChildren: () => import('../app/pages/payroll-expenses/payroll-expenses.module').then( m => m.PayrollExpensesModule) },
      { path: 'notifications', loadChildren: () => import('../app/pages/notifications/notifications.module').then( m => m.NotificationsModule) },
      { path: 'activities', loadChildren: () => import('../app/pages/activity/activity.module').then( m => m.ActivityModule) },
      { path: 'cash-account-management', loadChildren: () => import('../app/pages/cash-account-management/cash-account-management.module').then( m => m.CashAccountManagementModule) },
      { path: 'privacy-policy', component: PrivacyPolicyComponent,data :{sidebar:true, title:"Privacy policy"}  },
      { path: 'corporate-safety', component: CorporateSafetyComponent,data :{sidebar:true, title:"Corporate safety"}  },
      { path: 'feedback-survey', loadChildren: () => import('../app/pages/feedback-survey/feedback-survey.module').then( m => m.FeedbackSurveyModule) },
    
      { path: 'news-announcements', loadChildren: () => import('../app/pages/news-announcement/news-announcement.module').then( m => m.NewsAnnouncementModule) },

    ],
    data :{sidebar:true} 
  },
  {
    path: 'battery-optimization-required',
    loadChildren: () => import('./battery-optimization-required/battery-optimization-required.module').then( m => m.BatteryOptimizationRequiredPageModule)
  }
];


@NgModule({
  imports: [
    RouterModule.forRoot(routes, { preloadingStrategy: PreloadAllModules }),
    CommonModule
  ],
  exports: [RouterModule]
})
export class AppRoutingModule { }
